import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PaymentTransactionSchema = withDefaults({
  type: 'payment-transaction',
  fields: [
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'checkNumber',
    },
    {
      kind: 'attribute',
      name: 'companyContribution',
    },
    {
      kind: 'attribute',
      name: 'currentBalance',
    },
    {
      kind: 'attribute',
      name: 'endToEndId',
    },
    {
      kind: 'attribute',
      name: 'instructionId',
    },
    {
      kind: 'attribute',
      name: 'interestRate',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'isCredit',
    },
    {
      kind: 'attribute',
      name: 'minMonthlyPayment',
    },
    {
      kind: 'attribute',
      name: 'paymentAch',
    },
    {
      kind: 'attribute',
      name: 'transactionDate',
    },
    {
      kind: 'attribute',
      name: 'transactionDescription',
    },
    {
      kind: 'attribute',
      name: 'transactionStatusType',
    },
    {
      kind: 'attribute',
      name: 'userContribution',
    },
    {
      kind: 'attribute',
      name: 'financialInstitutionName',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'updatedBy',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'loan',
      type: 'loan',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'invoiceLineItem',
      type: 'invoice-line-item',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'financialInstitution',
      type: 'financial-institution',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'account',
      type: 'account',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default PaymentTransactionSchema;
